module.exports = __webpack_public_path__ + "shopping-bag.svg?a756bc";


//////////////////
// WEBPACK FOOTER
// ./client/assets/shopping-bag.svg
// module id = 143
// module chunks = 0